'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useMenuSection } from '@react-aria/menu';
import { MenuItemInternal } from './menu-item-internal.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, n = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), n.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t.push.apply(t, n);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function MenuSectionInternal({ section: o, state: c }) {
    let { itemProps: i, headingProps: s, groupProps: a } = useMenuSection({
        heading: o.rendered,
        'aria-label': o['aria-label']
    });
    return jsxs("li", _object_spread_props(_object_spread({}, i), {
        children: [
            o.rendered && jsx("span", _object_spread_props(_object_spread({}, s), {
                className: "swan-listbox-section-title swan-menu-section-title",
                children: o.rendered
            })),
            jsx("ul", _object_spread_props(_object_spread({}, a), {
                className: "swan-listbox-section swan-menu-section",
                children: [
                    ...o.childNodes
                ].map((r)=>jsx(MenuItemInternal, {
                        item: r,
                        state: c
                    }, r.key))
            }))
        ]
    }));
}

export { MenuSectionInternal };
